import { type ComponentPropsWithoutRef, useRef } from "react";

import { cn } from "@/shared/lib/utils";

import { useRevealOnMount } from "./useRevealOnMount";

export interface ColocaRevealProps extends ComponentPropsWithoutRef<"div"> {
  /** Seconds between two `[data-reveal]` children. */
  stagger?: number;
  delay?: number;
  /** Values that replay the entrance when they change (a wizard step). */
  replayOn?: readonly unknown[];
}

/**
 * A container whose `[data-reveal]` children fade up in sequence when it mounts. Mark the children that move;
 * everything else stays put, which is the point: one entrance, not a page of moving parts.
 */
export function ColocaReveal({ stagger, delay, replayOn, className, children, ...rest }: ColocaRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  useRevealOnMount(ref, { stagger, delay, deps: replayOn });
  return (
    <div ref={ref} className={cn(className)} {...rest}>
      {children}
    </div>
  );
}
